// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const cardClasses = {
  avatar: "qui-card__avatar",
  badge: "qui-card__badge",
  button: "qui-card__button",
  content: "qui-card__content",
  eyebrowText: "qui-card__eyebrow-text",
  footer: "qui-card__footer",
  heading: "qui-card__heading",
  headingText: "qui-card__heading-text",
  link: "qui-card__link",
  media: "qui-card__media",
  menuTrigger: "qui-card__menu-trigger",
  paragraphText: "qui-card__paragraph-text",
  root: "qui-card__root",
  subheadingText: "qui-card__subheading-text",
} as const
